import CustomBreadCrumb from '../../../components/Common/CustomBreadCrumb'
import TrackingList from '../../../components/Main/Tracking/TrackingList'
import PageTitle from '../../../elements/PageTitle'
import { Card, Layout, Row } from 'antd'
import React, { Fragment } from 'react'

const { Content } = Layout

function Tracking (props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <CustomBreadCrumb
              items={[
                { text: 'Operation' },
                { text: 'Order' },
                { text: 'Tracking Orders', link: '#/tracking' },
              ]}
            />
            <PageTitle
              title={'Tracking Orders'}
              subtitle={'Tracking Orders Management Center'}
              color={'#427035'}
              iconType={'file-unknown'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <TrackingList {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

Tracking.propTypes = {}
Tracking.defaultProps = {}

export default Tracking
